<template>
  <div class="header" v-header="'#banner'">
    <div class="header-wrap clearfix">
      <div class="logo">
        <img src="../../../public/static/img/common/travel-x.png" alt="" />
      </div>

      <!-- 导航 -->
      <div class="nav">
        <!-- <router-link :to="{ path: '/home' }" active-class="active"
          >首页</router-link
        > -->
        <div
          :class="{ clickActive: $route.path === '/home' }"
          class="aaa"
          @click="jump('/home')"
        >
          {{ $t("header.home") }}
        </div>
        <div
          :class="{ clickActive: $route.path === '/media' }"
          class="aaa"
          @mouseenter="showMedia"
          @mouseleave="hiddenMedia"
          @click="jump('/media')"
        >
          {{ $t("header.media") }}
          <i :class="[isShowMedia ? 'icon-caret-reverse' : 'icon-caret']"></i>
        </div>
        <div
          :class="{ clickActive: $route.path === '/solution' }"
          class="aaa"
          @mouseenter="showSolution"
          @mouseleave="hiddenSolution"
          @click="jump('/solution')"
        >
          {{ $t("header.solution")
          }}<i
            :class="[isShowSolution ? 'icon-caret-reverse' : 'icon-caret']"
          ></i>
        </div>
        <div
          :class="{ clickActive: $route.path === '/travel' }"
          class="aaa"
          @mouseenter="showTravel"
          @mouseleave="hiddenTravel"
          @click="jump('/travel')"
        >
          {{ $t("header.travel")
          }}<i
            :class="[isShowTravel ? 'icon-caret-reverse' : 'icon-caret']"
          ></i>
        </div>
        <div
          :class="{ clickActive: $route.path === '/recruit' }"
          class="aaa"
          @click="jump('/recruit')"
        >
          {{ $t("header.recruit") }}
        </div>

        <div class="langStyle">
          <div class="lang_widthHeight" v-if="lang === 'en'">
            <img
              @click="changeLang('zh')"
              src="../../../public/static/img/header/chinese.png"
              alt=""
            />
          </div>

          <div class="lang_widthHeight" v-else>
            <img
              @click="changeLang('en')"
              src="../../../public/static/img/header/english.png"
              alt=""
            />
          </div>
        </div>
      </div>

      <!-- 媒体 -->
      <div class="description des_widthHeight" v-show="isShowMedia">
        <div class="every_description">
          <div class="triangle"></div>
          <div class="description_title">{{ $t("header.overview") }}</div>
          <div class="description_content">
            {{ $t("header.overview_") }}
          </div>
        </div>

        <div class="every_description">
          <div class="triangle"></div>
          <div class="description_title">{{ $t("header.airport") }}</div>
          <div class="description_content">
            {{ $t("header.airport_") }}
          </div>
        </div>

        <div class="every_description">
          <div class="triangle"></div>
          <div class="description_title">{{ $t("header.free") }}</div>
          <div class="description_content">
            {{ $t("header.free_") }}
          </div>
        </div>

        <div
          class="every_description"
          @click="
            $router.push('solution?type=portusAir');
            isShowSolution = false;
          "
        >
          <div class="triangle"></div>
          <div class="description_title">{{ $t("header.brand") }}</div>
          <div class="description_content">
            {{ $t("header.brand_") }}
          </div>
        </div>

        <div
          class="every_description"
          @click="
            $router.push('solution?type=portusFin');
            isShowSolution = false;
          "
        >
          <div class="triangle"></div>
          <div class="description_title">{{ $t("header.place") }}</div>
          <div class="description_content">
            {{ $t("header.place_") }}
          </div>
        </div>
      </div>
      <!-- 系统解决方案 -->
      <div
        class="description solution_widthHeight"
        v-show="isShowSolution"
        @mouseenter="inDescription"
        @mouseleave="outDescription"
      >
        <div
          class="every_description"
          @click="
            $router.push('solution');
            isShowSolution = false;
          "
        >
          <div class="triangle"></div>
          <div class="description_title">{{ $t("header.overview") }}</div>
          <div class="description_content">
            {{ $t("header.overview_") }}
          </div>
        </div>

        <div
          class="every_description"
          @click="
            $router.push('media');
            isShowSolution = false;
          "
        >
          <div class="triangle"></div>
          <div class="description_title">PortusPlus</div>
          <div class="description_content">
            {{ $t("header.portusPlus") }}
          </div>
        </div>

        <div
          class="every_description"
          @click="
            $router.push('solution?type=portus');
            isShowSolution = false;
          "
        >
          <div class="triangle"></div>
          <div class="description_title">Portus</div>
          <div class="description_content">
            {{ $t("header.portus") }}
          </div>
        </div>

        <div
          class="every_description"
          @click="
            $router.push('solution?type=portusAir');
            isShowSolution = false;
          "
        >
          <div class="triangle"></div>
          <div class="description_title">PortusAir</div>
          <div class="description_content">
            {{ $t("header.portusAir") }}
          </div>
        </div>

        <div
          class="every_description"
          @click="
            $router.push('solution?type=portusFin');
            isShowSolution = false;
          "
        >
          <div class="triangle"></div>
          <div class="description_title">PortusFin</div>
          <div class="description_content">
            {{ $t("header.portusFin") }}
          </div>
        </div>
      </div>
      <!-- 全球旅行购 -->
      <div class="description travel_widthHeight" v-show="isShowTravel">
        <div class="every_description">
          <div class="triangle"></div>
          <div class="description_title">{{ $t("header.travel") }}</div>
          <div class="description_content">{{ $t("header.travel_") }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "myHeader",
  data () {
    return {
      isShowMedia: false,
      isShowSolution: false,
      isShowTravel: false,
      lang: localStorage.getItem('PortusLang') || 'en'
    };
  },
  methods: {
    changeLang (lang) {
      this.lang = lang
      localStorage.setItem('PortusLang', lang)
      this.$i18n.locale = lang // 设置给本地的i18n插件
      window.location.reload()
    },
    showTravel () {
      this.isShowTravel = true
    },
    hiddenTravel () {
      this.isShowTravel = false
    },
    showSolution () {
      this.isShowSolution = true
    },
    hiddenSolution () {
      this.isShowSolution = false
    },
    inDescription () {
      this.isShowSolution = true
    },
    outDescription () {
      this.isShowSolution = false
    },
    showMedia () {
      this.isShowMedia = true
    },
    hiddenMedia () {
      this.isShowMedia = false
    },
    jump (link) {
      this.isShowMedia = false
      this.isShowSolution = false
      this.isShowTravel = false
      this.$router.push({
        path: link
      })
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.aaa {
  float: left;
  color: #333;
  font-weight: 400;
  line-height: 86px;
  position: relative;
  margin-right: 50px;
  text-align: center;
  cursor: pointer;
}
.clickActive {
  font-weight: 700;
}
.lang {
  height: 86px;
  display: inline-block;
  a {
    display: inline-block;
    font-size: 14px;
    width: 32px;
    height: 32px !important;
    line-height: 32px !important;
    border-radius: 50%;
    border: 1px solid #fff;
    float: none !important;
  }
  a::after {
    content: none !important;
  }
}
.lang::after {
  content: none !important;
}
.page-container .header.sticky .header-wrap .nav .lang a {
  border: 1px solid #2e2e2e;
}

.result {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  &:before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
  }
}

.frame {
  width: 500px;
  height: 320px;
  border-radius: 10px;
  background: #ffffff;
  z-index: 99;
  position: relative;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  box-sizing: border-box;
}
.frame .close {
  z-index: 99;
  width: 32px;
  height: 32px;
  position: relative;
  top: -320px;
  right: -520px;
  cursor: pointer;
  background: url("~static/img/common/cancel.png") no-repeat center / cover;
}
.frame .content {
  width: 100%;
  height: 100%;
  text-align: center;
  box-sizing: border-box;
}
.content h1 {
  width: 100%;
  height: 90px;
  line-height: 80px;
  text-align: center;
  font-size: 20px;
  font-family: "RobotoSlab-Regular" !important;
  color: #202020;
}
.content .btn-container {
  margin-bottom: 20px;
  .btn {
    width: 300px;
    height: 50px;
    background: #ff5702;
    font-size: 16px;
    font-family: "RobotoSlab-Regular" !important;
    color: #ffffff;
    border: none;
    outline: none;
  }
  .btn[disabled] {
    cursor: not-allowed;
    opacity: 0.6;
  }
}
.content input {
  width: 300px;
  height: 50px;
  border-radius: 5px;
  outline: none;
  border: none;
  margin-bottom: 20px;
}
.content input.active {
  border: 1px solid #ff5702;
}
input::-webkit-input-placeholder {
  color: #efbca4;
  font-family: "RobotoSlab-Regular" !important;
}
.content .code {
  background: #f7e6de;
  padding-left: 10px;
  box-sizing: border-box;
  font-size: 16px;
  color: #333333;
  border: 1px solid #f7e6de;
}
.content .code:active,
.content .code:focus {
  border: 1px solid #ff5702;
}
.content .code.error {
  border: 1px solid #f00;
}

.content p {
  width: 100%;
  height: 80px;
  line-height: 1.3;
  display: block;
  padding-left: 27px;
  font-size: 12px;
  color: #333333;
  text-align: left;
  margin-top: 10px;
  font-family: "RobotoSlab-Regular" !important;
  background: #e8e8e8;
  border-radius: 0 0 10px 10px;
  padding-top: 20px;
  box-sizing: border-box;
  text-align: left;
}
.content p span {
  font-weight: 600;
}
</style>
